<p-toolbar class="mb-4 flex flex-wrap gap-2">
  <ng-template pTemplate="left">
    <div class="flex flex-wrap gap-2">
      <p-button
        [rounded]="true"
        [disabled]="!selectedProducts?.length || loading"
        [loading]="loading"
        label="Generar etiquetas estanterías"
        icon="pi pi-tags"
        (onClick)="generateLabels('estanteria')"
      />
      <p-button
        [rounded]="true"
        [disabled]="!selectedProducts?.length || loading"
        [loading]="loading"
        label="Generar A6"
        icon="pi pi-tags"
        (onClick)="generateLabels('a6')"
      />
      <p-button
        [rounded]="true"
        [disabled]="!selectedProducts?.length || loading"
        [loading]="loading"
        label="Generar A5"
        icon="pi pi-tags"
        (onClick)="generateLabels('a5')"
      />
      <p-button
        [rounded]="true"
        [disabled]="!selectedProducts?.length || loading"
        [loading]="loading"
        label="Generar AA"
        icon="pi pi-tags"
        (onClick)="generateLabels('a4')"
      />
      <p-button
        [rounded]="true"
        [disabled]="!selectedProducts?.length || loading"
        [loading]="loading"
        label="Generar Pequeñas"
        icon="pi pi-tags"
        (onClick)="generateLabels('pequenas')"
      />
    </div>
  </ng-template>
</p-toolbar>

<div class="overflow-x-auto">
  <p-table
    #dt2
    [loading]="loading"
    [value]="products"
    [globalFilterFields]="['name', 'default_code', 'barcode']"
    [(selection)]="selectedProducts"
    dataKey="default_code"
    sortField="name"
    [sortOrder]="1"
    responsiveLayout="scroll"
    [tableStyle]="{'min-width': '50rem'}"
  >
    <ng-template #caption>
      <div class="flex flex-wrap items-center justify-end gap-2">
        <p-iconfield iconPosition="left">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            pInputText
            type="text"
            #searchBox
            (input)="dt2.filterGlobal(searchBox.value, 'contains')"
            placeholder="Buscar"
          />
        </p-iconfield>
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
        <th>Name</th>
        <th>Ref</th>
        <th>Código de barras</th>
        <th>PVP</th>
      </tr>
    </ng-template>

    <ng-template #body let-product>
      <tr>
        <td><p-tableCheckbox [value]="product" /></td>
        <td>{{ product.name }}</td>
        <td>{{ product.default_code }}</td>
        <td>
          {{ product.barcode || '' }}
          <ng-container *ngIf="!product.barcode">
            <p-button
              class="ml-2"
              [rounded]="true"
              icon="pi pi-barcode"
              (onClick)="read(product)"
            />
          </ng-container>
        </td>
        <td>{{ product.price_with_vat | currency: 'EUR' }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
